import { Theme } from '@radix-ui/themes'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useLocation } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import type { User } from 'types/user'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { getUser } from '@disco/state-management/selectors/user'
import DocumentHeadTags from 'components/document-head-tags'
import Modal from 'components/ui/disco-modal'
import modalStyles from 'components/utils/modalStyles'
import ChargebeeCardForm from './chargebee-card-form'

type OwnProps = {
  navigate: NavigateFunction
  location: Location
}

const mapStateToProps = (state: any) => ({
  user: getUser(state),
})

const mapDispatchToProps = {
  sendMixpanelEvent,
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type
type PropsFromRedux = ConnectedProps<typeof connector>

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class BillingUpdate extends React.Component<Props> {
  componentDidMount() {
    this.props.sendMixpanelEvent('Open Update payment details form')
  }

  _onClose = () => {
    if (
      this.props.user.business.private_metadata.expired_subscription &&
      this.props.location.pathname !== '/expired-subscription'
    ) {
      this.props.navigate('/expired-subscription')
    } else if (this.props.location?.state?.returnTo) {
      this.props.navigate(this.props.location.state.returnTo)
    } else {
      this.props.navigate('/settings/billing')
    }
  }

  render() {
    const { chargebee_subscription_id } = this.props.user.business

    const CardFormComponent = chargebee_subscription_id
      ? ChargebeeCardForm
      : null

    return (
      <Modal
        style={modalStyles}
        isOpen
        onRequestClose={this._onClose}
        className="ShortlistShareModal"
      >
        <Theme>
          <div className="Form">
            <DocumentHeadTags title="Settings | Billing | Update payment details | DISCO" />
            <div className="Admin_Section">
              <h2 className="Admin_Header">Update payment details</h2>
            </div>
            {CardFormComponent && (
              <CardFormComponent onRequestClose={this._onClose} />
            )}
          </div>
        </Theme>
      </Modal>
    )
  }
}

const ConnectedBillingUpdate = connector(BillingUpdate)

function BillingUpdateWithRouter(props: any) {
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <ConnectedBillingUpdate
      {...props}
      navigate={navigate}
      location={location}
    />
  )
}

export default BillingUpdateWithRouter
